<template>
    <div class="flex flex-col m-2">
        <div class="flex flex-row items-center">
            <label class="text-primary text-sm">{{label}}</label>
            <slot name="label"></slot>
            <div v-if="tooltip" v-tooltip="{content: tooltip, html: true}">
                
                <font-awesome-icon class="ml-2 text-primary" icon="info-circle" ></font-awesome-icon>
            </div>
            <div class="flex flex-grow"></div>
            <slot name="label-end"></slot>
        </div>
        <div v-if="flush" class="my-1">
            <slot name="comp"></slot>
        </div>
        <div v-else class="py-1 px-2 my-1 rounded bg-gradient-to-br from-gray-100 to-gray-150 shadow-inner flex flex-row items-center">
            <slot name="prefix"></slot>
            <slot name="comp"></slot>
            <slot name="suffix"></slot>
        </div>
    </div>
</template>
<script setup="props">
import { defineProps, defineComponent } from "vue";

// disable attributte inheritence
defineComponent({
    "inheritAttrs": false
});

// define the component props
defineProps({
    "label": String,
    "tooltip": String,
    "flush": Boolean
});

// get the attrb on the component and bind them to the input element
// const attrs = useAttrs();

</script>
<style scoped>
.level-1 {
    margin-left: 2rem;
}

.level-2 {
    margin-left: 4rem;
}
</style>
